module.exports = __webpack_public_path__ + "img/btn_learnmore.70d52d55.png";